import { functions } from '@/plugins/firebase';
import { AbstractAdapter } from "@/adapter/abstractAdapter";
import { getUserInfoApi } from "@/helper/functions";
import { httpsCallable } from 'firebase/functions';

export class CommonApi extends AbstractAdapter {

    async getUserInfo(): Promise<any> {
        this.startLoading();
        // 登録している書籍の詳細情報取得
        const getUserInfoFunc = httpsCallable(functions, getUserInfoApi);
        try {
            return await getUserInfoFunc({});
        } finally {
            this.finishLoading();
        }
    }
}
